import { computed, onBeforeUnmount, onMounted } from 'vue'
import { useThemeStore } from '@/app/stores/theme'
import { getActiveTheme } from '@/shared/theme/theme'

export function useTheme() {
  const store = useThemeStore()

  function syncResolvedTheme() {
    try {
      store.adoptResolvedTheme(getActiveTheme())
    } catch { store.initialize() }
  }

  onMounted(() => {
    store.initialize()
    window.addEventListener('vf-resolved-theme', syncResolvedTheme)
  })
  onBeforeUnmount(() => window.removeEventListener('vf-resolved-theme', syncResolvedTheme))

  return {
    theme: computed(() => store.name),
    isDark: computed(() => store.name === 'dark'),
    syncResolvedTheme,
  }
}
